// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-list {
  padding-top: 5px;
}

ion-grid {
  padding: 0px !important;
}

ion-radio {
  margin: 8px;
  margin-left: 8px;
}

.ion-item {
  padding: 0px;
  margin: 0px;
  margin-bottom: 15px;
  width: 100%;
  border: solid 1px #000 !important;
}

.item-inner {
  padding-right: 0px !important;
}

.button-submit {
  width: 50%;
}

.multiline-label {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/withdraw/withdrawal-echeck/withdrawal-echeck.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,iCAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ","sourcesContent":["ion-list {\n    padding-top: 5px;\n}\n\nion-grid {\n    padding: 0px !important;\n}\n\nion-radio {\n    margin: 8px;\n    margin-left: 8px;\n}\n\n.ion-item {\n    padding: 0px;\n    margin: 0px;\n    margin-bottom: 15px;\n    width: 100%;\n    border: solid 1px #000 !important;\n}\n\n.item-inner {\n    padding-right: 0px !important;\n}\n\n.button-submit {\n    width: 50%;\n}\n\n.multiline-label {\n    display: flex;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
